import { Button, ConfirmationDialog } from 'components/Elements';
import PropTypes from 'prop-types';
import { useBlockUser } from '../api/blockUser'; // You'll need to implement this hook
import { Lock } from 'lucide-react';

export const BlockUser = ({ id, userName }) => {
  const blockUserMutation = useBlockUser({ id });

  return (
    <ConfirmationDialog
      icon="warning"
      title="Block User"
      body={`Are you sure you want to block "${userName}"? They will not be able to access their wire24 mobile account.`}
      triggerButton={
        <button className="text-xs px-3 py-1 border border-white/10 rounded-md hover:bg-white/10 flex items-center space-x-1">
          <Lock size={14} />
          <span>Block</span>
        </button>
      }
      confirmButton={
        <Button
          isLoading={blockUserMutation.isLoading}
          type="button"
          variant="warning"
          onClick={() => {
            blockUserMutation.mutate({ id });
          }}
        >
          Confirm Block
        </Button>
      }
    />
  );
};

BlockUser.propTypes = {
  id: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};
